export const formatNumber = (number) => {
    if (number >= 1000000000000) {
        return (number / 1000000000000).toFixed(1).replace(/\.0$/, '') + 'T'; // Trillion
    }
    if (number >= 1000000000) {
        return (number / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B'; // Billion
    }
    if (number >= 1000000) {
        return (number / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'; // For million
    }
    if (number >= 1000) {
        return (number / 1000).toFixed(1).replace(/\.0$/, '') + 'k'; // For thousand
    }
    return number; // Return as is for numbers below 1000
};